const TOKEN = {
  ACCESS: "access_token",
  REFRESH: "refresh_token",
};

const ROUTE_PATHS = {
  // MAIN: "/",
  DASHBOARD1: "/",
  DASHBOARD2: "/dashboard-2",
  DIRECT: "/direct-investments",
  INTERNATIONAL: "/international-financial",
  STRATEGIC: "/strategic-projects",

};

const COMPACT_SCREEN_WIDTH = 1536;

export { TOKEN, ROUTE_PATHS, COMPACT_SCREEN_WIDTH };
